import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../auth/auth.store';

export const AuthGuard: CanActivateFn = (route, state) => {
    const authStore = inject(AuthStore);
    const router = inject(Router);

    const isAuthenticated = authStore.isAuthenticated();

    if (isAuthenticated) {
        return true;
    } else {
        router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
};
